var DataTableConfiguration = {
	assessment_data: {
		columns: [
	    { data: 'uid', name: 'uid' },
	    { data: 'gid', name: 'gid' },
	    { data: 'date', name: 'date' },
	    { data: 'status', name: 'status' },
	    { data: 'aptitude', name: 'aptitude' },
	    { data: 'behavior', name: 'behavior' },
	    { data: 'confidence', name: 'confidence' },
	    { data: 'ffs', name: 'ffs' },
		],
		order: [[0, 'asc']],
	},
	exports: {
		columns: [
	    { data: 'report', name: 'report' },
      { data: 'generated_by', name: 'generated_by' },
      { data: 'created_at', name: 'exported_on' },
	    { data: 'start_date', name: 'start_date' },
	    { data: 'end_date', name: 'end_date' },
	    { data: 'file', name: 'file', render: function (data, type, row) { 
        if (data) {
          return `<a href="${data}">${I18n.t('admin.download')}</a>`
        } else {
          return I18n.t('admin.report_queued')
        }
      } },
		],
		order: [[0, 'asc']],
	},
	learning_data: {
		columns: [
	    { data: 'uid', name: 'uid' },
	    { data: 'gid', name: 'gid' },
	    { data: 'date', name: 'date' },
	    { data: 'action', name: 'action' },
	    { data: 'score', name: 'score' },
	    { data: 'course_id', name: 'course_id' },
	    { data: 'course', name: 'course' },
	    { data: 'points_earned', name: 'points_earned' },
		],
		order: [[0, 'asc']],
	},	
	user_progress: {
		columns: [
	    { data: 'uid', name: 'uid' },
	    { data: 'gid', name: 'gid' },
	    { data: 'first_login', name: 'first_login' },
	    { data: 'logins', name: 'logins' },
	    // { data: 'checkup_date', name: 'checkup_date' },
	    { data: 'courses_added', name: 'courses_added' },
	    { data: 'courses_opened', name: 'courses_opened' },
	    { data: 'courses_passed', name: 'courses_passed' },
	    { data: 'courses_with_completed_quizzes', name: 'courses_with_completed_quizzes' },
	    { data: 'average_pre_test', name: 'average_pre_test' },
	    { data: 'average_highest_post_test', name: 'average_highest_post_test' },
			{ data: 'knowledge_delta', name: 'knowledge_delta' },
			{ data: 'total_points', name: 'total_points' },
		],
		order: [[0, 'asc']],
	}
}

export default DataTableConfiguration